import { createAction } from 'deox';
import {
  GET_USER_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UserState,
} from './types';

export const getUserAction = {
  request: createAction(GET_USER_REQUEST),
  success: createAction(GET_USER_SUCCESS, resolve => (user: UserState) => resolve(user)),
  failure: createAction(GET_USER_FAILURE, resolve => (message: string) => resolve(message)),
};

export const updatePasswordAction = {
  request: createAction(
    UPDATE_PASSWORD_REQUEST,
    resolve =>
      (payload: {
        old_password: string;
        password: string;
        onSuccess?: () => void;
        onFailure?: (message: string) => void;
      }) =>
        resolve(payload),
  ),
  success: createAction(UPDATE_PASSWORD_SUCCESS, resolve => (message: string) => resolve(message)),
  failure: createAction(UPDATE_PASSWORD_FAILURE, resolve => (message: string) => resolve(message)),
};
